<template>
  <VTooltip v-model="isActive" v-bind="$attrs" :disabled="!$slots.tooltip">
    <template #activator="{ attrs, on }">
      <slot v-bind="{ attrs, on }" />
    </template>
    <slot name="tooltip" />
  </VTooltip>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, watch } from 'vue'

import { TooltipParams, trackViewTooltip } from '@/components/mixins/analytics'

export default defineComponent({
  props: {
    analyticsName: {
      type: String,
      required: true
    },
    analyticsParams: {
      type: Object as PropType<TooltipParams>,
      default: () => ({})
    }
  },
  setup({ analyticsName, analyticsParams }) {
    const isActive = ref(false)
    watch(isActive, (show) => {
      if (show) {
        trackViewTooltip(analyticsName, analyticsParams)
      }
    })
    return {
      isActive
    }
  }
})
</script>
